<template>
  <div id="app" @mouseover="OperatingWebsite()" @mousedown="OperatingWebsite()" @keydown="OperatingWebsite()">
    <transition name="slide-fade">
      <router-view />
    </transition>
  </div>
</template>

<script>
import './style/theme.less'
export default {
  name: 'App',
  data() {
    return {
      currentTime: new Date().getTime()
    }
  },
  created() {
    // eslint-disable-next-line no-undef
    hiddenInitLoading()
  },
  methods: {
    sign(link) {
      const param = {
        // cid: this.$route.params.id,
        cid: '1',
        url: window.location.href.split('#')[0]
      }
      this.$formUrlencoded('/wechat/sign', param).then(
        result => {
          if (result.status === 200) {
            wx.config({
              debug: false,
              // appId: 'wx3eb7e979c4024c83',
              // appId: 'wx5d4de6267db6f700', // 联众
              appId: 'wx66b5ace206eaded0', // 联众
              timestamp: result.data.timestamp,
              nonceStr: result.data.nonceStr,
              signature: result.data.signature,
              jsApiList: [
                'onMenuShareTimeline',
                'onMenuShareAppMessage',
                'onMenuShareQQ',
                'onMenuShareQZone',
                'updateAppMessageShareData',
                'updateTimelineShareData',
                'onMenuShareWeibo'
              ]
            })
            wx.ready(function() {
              // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0）
              wx.updateAppMessageShareData({
                title: '代账公司智能系统', // 分享标题
                desc:
                  '代账公司智能OA系统，多人协同作业，数据云端保存，工商案件、客户收款登记一键录入，手机端+PC端随时查阅！', // 分享描述
                link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: 'http://17l.link/dist/icon-logo.jpg', // 分享图标
                success: function() {
                  // 设置成功
                }
              })
              // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0）
              wx.updateTimelineShareData({
                title: '代账公司智能系统', // 分享标题
                link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: 'http://17l.link/dist/icon-logo.jpg', // 分享图标
                success: function() {
                  // 设置成功
                }
              })
              // 获取“分享到朋友圈”按钮点击状态及自定义分享内容接口（即将废弃）
              wx.onMenuShareTimeline({
                title: '代账公司智能系统', // 分享标题
                link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: 'http://17l.link/dist/icon-logo.jpg', // 分享图标
                success: function() {
                  // 用户点击了分享后执行的回调函数
                }
              })
              // 获取“分享给朋友”按钮点击状态及自定义分享内容接口（即将废弃）
              wx.onMenuShareAppMessage({
                title: '代账公司智能系统', // 分享标题
                desc:
                  '代账公司智能OA系统，多人协同作业，数据云端保存，工商案件、客户收款登记一键录入，手机端+PC端随时查阅！', // 分享描述
                link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: 'http://17l.link/dist/icon-logo.jpg', // 分享图标
                type: '', // 分享类型,music、video或link，不填默认为link
                dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                success: function() {
                  // 用户点击了分享后执行的回调函数
                }
              })
              // 获取“分享到QQ”按钮点击状态及自定义分享内容接口（即将废弃）
              wx.onMenuShareQQ({
                title: '代账公司智能系统', // 分享标题
                desc:
                  '代账公司智能OA系统，多人协同作业，数据云端保存，工商案件、客户收款登记一键录入，手机端+PC端随时查阅！', // 分享描述
                link: link, // 分享链接
                imgUrl: 'http://17l.link/dist/icon-logo.jpg', // 分享图标
                success: function() {
                  // 用户确认分享后执行的回调函数
                },
                cancel: function() {
                  // 用户取消分享后执行的回调函数
                }
              })
              // 获取“分享到腾讯微博”按钮点击状态及自定义分享内容接口
              wx.onMenuShareWeibo({
                title: '代账公司智能系统', // 分享标题
                desc:
                  '代账公司智能OA系统，多人协同作业，数据云端保存，工商案件、客户收款登记一键录入，手机端+PC端随时查阅！', // 分享描述
                link: link, // 分享链接
                imgUrl: 'http://17l.link/dist/icon-logo.jpg', // 分享图标
                success: function() {
                  // 用户确认分享后执行的回调函数
                },
                cancel: function() {
                  // 用户取消分享后执行的回调函数
                }
              })
              // 获取“分享到QQ空间”按钮点击状态及自定义分享内容接口（即将废弃）
              wx.onMenuShareQZone({
                title: '代账公司智能系统', // 分享标题
                desc:
                  '代账公司智能OA系统，多人协同作业，数据云端保存，工商案件、客户收款登记一键录入，手机端+PC端随时查阅！', // 分享描述
                link: link, // 分享链接
                imgUrl: 'http://17l.link/dist/icon-logo.jpg', // 分享图标
                success: function() {
                  // 用户确认分享后执行的回调函数
                },
                cancel: function() {
                  // 用户取消分享后执行的回调函数
                }
              })
            })
            wx.error(res => {
              console.log(res)
              this.$dialog.alert({
                message: '微信授权失败!' + res.errMsg
              })
            })
          } else {
            this.$dialog.alert({
              message: result.msg
            })
          }
        },
        error => {
          this.$dialog.alert({
            message: error.message
          })
        }
      )
    },
    /**
     * 定义 alert
     * type:  success / info / warning / error
     */
    vueAlert(options, activity) {
      var message = ''
      if (typeof options === 'string' && options.constructor === String) {
        // 兼容原来 text
        message = options
        options = {
          message: message,
          showClose: false
        }
      }
      options.title = options.title ? options.title : '提示'
      options.showClose = options.showClose ? options.showClose : false
      var customClass = options.type ? 'alert-custom-' + options.type : '' // MessageBox 的自定义类名

      if (typeof options.message === 'object') {
        // 解析 错误信息
        const msg = options.message.message
        if (message === 'Timeout') {
          options.message = 'Error: ' + msg + ' 请求超时'
        } else {
          options.message = 'Error: ' + msg
        }
      }
      this.$alert(options.message, options.title, {
        showClose: false,
        type: options.type,
        customClass: customClass,
        dangerouslyUseHTMLString: true,
        confirmButtonText: options.confirmButtonText || '确定',
        callback: () => {
          activity && activity()
        }
      })
    },
    /**
     * 定义 confirm
     * type:  success / info / warning / error
     */
    vueConfirm(options, activity, cancel) {
      var message = ''
      if (typeof options === 'string' && options.constructor === String) {
        // 兼容原来 text
        message = options
        options = {
          message: message,
          showClose: false
        }
      }
      options.title = options.title ? options.title : '提示'
      options.showClose = options.showClose ? options.showClose : false
      var customClass = options.type ? 'alert-custom-' + options.type : '' // MessageBox 的自定义类名
      var cancelButtonClass = options.cancelButtonClass ? options.cancelButtonClass : '' // MessageBox 的自定义类名
      this.$confirm(options.message, options.title, {
        showClose: true,
        type: options.type,
        customClass: customClass,
        cancelButtonClass: cancelButtonClass || 'el-button--primary is-plain',
        confirmButtonText: options.confirmButtonText || '确定',
        cancelButtonText: options.cancelButtonText || '取消',
        dangerouslyUseHTMLString: true
      })
        .then(() => {
          activity && activity()
        })
        .catch(() => {
          cancel && cancel()
        })
    },
    // 长时间未操作，自动登出设置
    OperatingWebsite() {
      // let currentTime
      // if (sessionStorage.getItem('currentTime')) {
      //   currentTime = sessionStorage.getItem('currentTime')
      // } else {
      //   currentTime = this.currentTime
      // }
      // const lastTime = new Date().getTime()
      // const timeOut = 10 * 60 * 1000 // 设置时间 10分钟
      // // let timeOut = 10 * 1000; //设置时间 10分钟
      // if (lastTime - currentTime > 1000 * 60) {
      //   console.log((lastTime - currentTime) / 1000)
      // }
      // if (this.$route.path === '/') {
      //   this.currentTime = new Date().getTime()
      //   sessionStorage.setItem('currentTime', this.currentTime)
      //   return
      // }
      // if (lastTime - currentTime > timeOut) {
      //   // 未操作页面，跳转登录页面
      //   this.currentTime = new Date().getTime()
      //   // this.vueAlert({ message: '超过10分钟未操作，请重新登录！', type: 'warning' }, () => {
      //   //   sessionStorage.clear()
      //   //   this.$router.push({
      //   //     path: '/',
      //   //     query: {
      //   //       name: name
      //   //     }
      //   //   })
      //   // })
      // } else {
      //   this.currentTime = new Date().getTime()
      //   sessionStorage.setItem('currentTime', this.currentTime)
      // }
    }
  },
  // 监听,当路由发生变化的时候执行
  mounted() {}
}
</script>

<style lang="less">
* {
  margin: 0;
  padding: 0;
}
html,
body,
section,
main,
aside,
aside ul {
  height: 100%;
  width: 100%;
}
html,
body {
  font-size: 12px;
}
#app {
  font-family: 'PingFang SC', 'Helvetica Neue', Helvetica, 'microsoft yahei', arial, STHeiTi, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  height: 100%;
}
#app li.nolist {
  list-style: none;
}
#app .w-e-text-container li,
#app .w-e-text-container li {
  list-style: inherit;
}
</style>
